import React, { useContext, useEffect, useState, useCallback } from 'react'
import { ClearTheChartsContext } from '../ClearTheChartsContext'
import ChartAccuracy from './ChartAccuracy'
import ChartGeneralStats from './ChartGeneralStats'
import ChartGrid from './ChartGrid'
import ChartName from './ChartName'
import CHartStatsNavigation from './ChartStatsNavigation'
import { getMatrixActions } from './utils'

const ChartStatsView = ({ colors }) => {
  const { state } = useContext(ClearTheChartsContext)

  const [matrixActions, setMatrixActions] = useState(null)
  const { chartStatsToShow } = state

  const {
    completedHandsAllTime,
    mistakenHandsAllTime,
    chart,
  } = chartStatsToShow

  const getMatrix = useCallback(async () => {
    if (!chart) return
    const { actions, URL } = chart
    const matrixActions = await getMatrixActions(URL, actions)
    setMatrixActions(matrixActions)
  }, [chart])

  useEffect(() => {
    getMatrix()
  }, [getMatrix])

  if (!chart) return null
  if (!matrixActions) return null
  return (
    <div>
      <CHartStatsNavigation />
      <ChartGeneralStats chart={chartStatsToShow} />
      <ChartAccuracy chart={chartStatsToShow} />
      <ChartName chart={chart} />
      <ChartGrid
        isSweeper={true}
        isChartStatsMode={true}
        completedHands={completedHandsAllTime}
        mistakenHands={mistakenHandsAllTime}
        showRanges={true}
        showOutOfRange={true}
        matrixActions={matrixActions}
        colors={colors}
      />
    </div>
  )
}

export default ChartStatsView
